export const SET_DASHBOARD_STATE = "SET_DASHBOARD_STATE";
export const SET_LOGIN_STATE = "SET_LOGIN_STATE";
